import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, MenuItem, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, TextField, Select, FormControl, InputLabel, Dialog, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { ROLE_API_URL, VENDOR_API_URL } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import EditPenIcon from "src/svgComponents/EditPenIcon";
import BinIcon from "src/svgComponents/BinIcon";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import FormHelperText from "@mui/material/FormHelperText";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import { reset } from "numeral";
import ShowImage from "../common/ShowImage";
import AppTooltip from "src/components/common/AppTooltip";
import useStore from 'src/contexts/AuthProvider';
import DefaultImage from "../../assets/images/Default_image.png";
import 'react-phone-input-2/lib/lib'
import PhoneInput from "react-phone-input-2";
import { LoadingButton } from '@mui/lab';
import ButtonText from "src/components/common/ButtonText";

const _ = require('lodash');

const SubVendor = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const axiosPrivate = useAxiosPrivate();
   const [openModal, setOpenModal] = useState(false);
   const [roleDatas, setRoleDatas] = useState();
   const [profilePic, setProfilePic] = useState("");
   const [imageName, setImageName] = useState();
   const [showImage, setShowImage] = useState();
   const [modelTitle, setmodelTitle] = useState("");
   const [filterName, setFilterName] = useState('');
   const [vendorRoleId, setVendorRoleId] = useState("");
   const [disable, setDisable] = useState(false);
   const [Id, setId] = useState("");
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const theme = useTheme();
   const [loading, setLoding] = useState(true);
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const randomstring = Math.random().toString(36).slice(-8);
   const permissionsData = useStore(state => state.permissions);
   const [uploadedImage, setUploadedImage] = useState();
   const [flag, setFlag] = useState();
   const [phoneValue, setPhoneValue] = useState();
   const [buttonLoading, setButtonLoding] = useState(false);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'name', label: 'Name', alignRight: false },
      { id: 'email', label: 'Email', alignRight: false },
      { id: 'businessPhone', label: 'Business Phone', alignRight: false },
      { id: 'vendor_role_id', label: 'Assign Role Name', alignRight: false },
      { id: 'image', label: 'Image', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getSubVendor(page, filterName) {
      const response = await axiosPrivate.get(VENDOR_API_URL.getSubVendor, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: vendorList, refetch } = useQuery(['vendorList', page, filterName], () => getSubVendor(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (vendorList) {
         setTableData(vendorList.data);
         setRowsPerPage(vendorList?.metadata.length !== 0 ? vendorList?.metadata[0].limit : 10);
      }
      if (vendorList?.metadata.length !== 0 && vendorList?.metadata[0].hasMoreData === true) {
         getSubVendor(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [vendorList])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getSubVendor(page, filterName)
      refetch();
   };

   async function getRolesData() {
      const response = await axiosPrivate.get(ROLE_API_URL.getVendorRole)
      return response.data;
   }
   const { data: roleData } = useQuery(['roleData'], () => getRolesData(), { keepPreviousData: true, })
   useEffect(() => {
      if (roleData !== undefined) {
         setRoleDatas(roleData)
      }
   }, [roleData])

   const completedSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, "Name can set of between 2 and 50 characters!")
         .max(50, "Name can set of between 2 and 50 characters!")
         .required("Name is required"),
      email: Yup.string().required('Email is required'),
      businessPhone: Yup.string()
         .required("Business Phone is required"),
      vendor_role_id: Yup.string().required('Role is required'),
   });

   const handleUploadImage = async () => {
      const formData = new FormData();
      formData.append('image', uploadedImage)
      const imageData = await axiosPrivate
         .post(VENDOR_API_URL.uploadImage, formData)
         .catch((e) => {
            setButtonLoding(false);
            enqueueSnackbar(e?.response?.data?.message, {
               variant: "error",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
         });
      setImageName(imageData?.data?.file_name)
      setFieldValue("image", imageData?.data?.file_name)
      return imageData?.data?.file_name;
   }

   const formik = useFormik({
      initialValues: {
         name: "",
         email: "",
         businessPhone: "",
         vendor_role_id: "",
         image: ""
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         if (values.vendor_role_id === '') {
            setFieldError({ vendor_role_id: 'Please select role' });
            return;
         } else {
            let image_name = '';
            if (!imageName) {
               if (flag === 'asd') {
                  image_name = await handleUploadImage();
               }
            } else {
               image_name = imageName
            }
            if (image_name) {
               setButtonLoding(true);
            }
            const informationObj = {
               name: values.name,
               email: values.email,
               businessPhone: phoneValue,
               image: image_name
            };
            if (vendorRoleId) {
               informationObj.vendor_role_id = vendorRoleId;
            }
            if (Id === "") {
               await subVendorAdd(informationObj);
            } else {
               await subVendorUpdate(informationObj);
            }
            setVendorRoleId("");
            setImageName("");
            resetForm();
            setSubmitting(false);
         }
      },
   });

   const { mutateAsync: subVendorAdd } = useMutation(
      async (data) => {
         return await axiosPrivate.post(VENDOR_API_URL.addSubVendor, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Sub Vendor add successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            setButtonLoding(false);
            handleCloseModal();
            refetch();
         },
         onError: (error) => {
            setButtonLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               }
               else if (key === "vendor_role_id") {
                  setFieldError("vendor_role_id", errorData[key]);
               }
               else if (key === "email") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "businessPhone") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "image") {
                  setFieldError(key, errorData[key]);
               }
               else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   const { mutateAsync: subVendorUpdate } = useMutation(
      async (data) => {
         return await axiosPrivate.put(VENDOR_API_URL.editSubVendor + Id, data)
      },
      {
         onSuccess: ({ data }) => {
            refetch();
            setButtonLoding(false);
            enqueueSnackbar("Sub Vendor update successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
         },
         onError: (error) => {
            setButtonLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }

   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
      setShowImage('');
   };

   const deleteSubVendor = async () => {
      const response = await axiosPrivate.delete(VENDOR_API_URL.deleteSubVendor + deleteId)
      if (response.status === 200) {
         enqueueSnackbar("Sub Vendor delete successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleOpenModalAdd = () => {
      setFieldValue('name', "")
      setFieldValue('email', "")
      setFieldValue('businessPhone', "")
      setFieldValue('vendor_role_id', "")
      setFieldValue('password', randomstring)
      setShowImage('');
      setImageName('');
      setFlag('')
      setId('')
      setmodelTitle('Sub Vendor Add')
      setDisable(false);
      setOpenModal(true);
   };

   const handleOpenModalUpdate = (row) => {
      setVendorRoleId(row?.vender_role_data?._id)
      setFieldValue("vendor_role_id", row?.vender_role_data?._id)
      setFieldValue('name', row?.name)
      setFieldValue('email', row?.email)
      handlePhoneValue(row?.businessPhone)
      setFieldValue('image', row?.image)
      setShowImage(row?.image)
      setId(row._id)
      setmodelTitle('Sub Vendor Update')
      setDisable(true);
      setOpenModal(true);
   };

   const handleClickOpen = (categoryId, categoryType) => {
      setdeleteId(categoryId);
      setOpen(true);
   };

   const handleCloseModal = () => {
      reset();
      setVendorRoleId('');
      setImageName('');
      setProfilePic('');
      setOpenModal(false);
      setPhoneValue('');
      resetForm();
   };

   const handleProfilePicOnChange = async (ev) => {
      if (ev.type.includes("image")) {
         setUploadedImage(ev);
         let userImgSrc = URL.createObjectURL(ev);
         setProfilePic(userImgSrc);
         setImageName('')
      } else {
         enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
   };

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched, resetForm } = formik;

   const handleRoleOnChange = (event) => {
      setFieldValue("vendor_role_id", event.target.value);
      setVendorRoleId(event.target.value);
   };

   const changeStatus = async (id) => {
      const response = await axiosPrivate.put(VENDOR_API_URL.changeStatus + id)
      if (response?.data?.message) {
         enqueueSnackbar(response?.data?.message, {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch()
   }

   const removeImage = () => {
      setProfilePic('');
      setShowImage('');
      setImageName('');
   }

   const handlePhoneValue = (e) => {
      setPhoneValue(e);
      setFieldValue('businessPhone', e)
   }

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Sub Vendors</h4>
            <Box className="d-flex align-items-center">
               <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="search ..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
               <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                  {permissionsData?.sub_vendor?.substring(1, 2) == "1" ?
                     <AppTooltip title="Add Sub Vendor" placement="bottom">
                        <ButtonText text={'Add Sub Vendor'} onClickBtn={() => handleOpenModalAdd()} />
                     </AppTooltip> : ''}
               </Stack>
            </Box>
         </div>
         <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
               <Stack direction={"row"} spacing={2} justifyContent={'center'}>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                     cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={() => deleteSubVendor()} autoFocus>
                     delete
                  </Button>
               </Stack>
            </DialogContent>
         </Dialog>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={vendorList?.data?.length}
                     onRequestSort={handleRequestSort}
                  />
                  {filteredUsers?.length > 0 ?
                     <TableBody>
                        {filteredUsers.map((row) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell component="th" scope="row"> {row.name} </TableCell>
                                 <TableCell component="th" scope="row"> {row.email} </TableCell>
                                 <TableCell component="th" scope="row"> +{row.businessPhone} </TableCell>
                                 <TableCell component="th" scope="row"> {row.vender_role_data?.name} </TableCell>
                                 <TableCell component="th" scope="row">
                                    <img src={row.image ? process.env.REACT_APP_PROFILE_URL + 'vendor/' + row.image : DefaultImage} height="53px" width="73px" alt="profile" />
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status === 1 ? <Chip variant="contained" label="Enable" className="app_status_chip accepted" onClick={() => changeStatus(row._id)} /> : <Chip variant="contained" className="app_status_chip invalid" label="Disable" onClick={() => changeStatus(row._id)} />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {permissionsData?.sub_vendor?.substring(3, 4) == "1" ?
                                          <AppTooltip title="Edit" placement="bottom">
                                             <Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleOpenModalUpdate(row)} variant="text" className="user_list_row_btn"><EditPenIcon /></Button>
                                          </AppTooltip> : ''}
                                       {permissionsData?.sub_vendor?.substring(2, 3) == "1" ?
                                          <AppTooltip title="Delete" placement="bottom">
                                             <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                          </AppTooltip> : ''}
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={vendorList?.metadata.length !== 0 ? vendorList?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
         <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>{modelTitle}</h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>
            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2">
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        <div className="col-lg-6">
                           <div className="form-group mb-3">
                              <TextField
                                 label='Name'
                                 name='name'
                                 autoComplete='off'
                                 fullWidth
                                 variant='outlined'
                                 {...getFieldProps("name")}
                              />
                              {errors.name && touched.name && <FormHelperText error>{errors.name}</FormHelperText>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-3">
                              <TextField
                                 label='Email'
                                 name='email'
                                 autoComplete='off'
                                 fullWidth
                                 variant='outlined'
                                 {...getFieldProps("email")}
                              />
                              {errors.email && touched.email && <FormHelperText error>{errors.email}</FormHelperText>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-3">
                              <PhoneInput
                                 className="react-tel-input-white"
                                 specialLabel="Business Phone"
                                 country={'india'}
                                 value={phoneValue}
                                 onChange={(phone) => handlePhoneValue(phone)}
                                 renderInput={(props) => <TextField {...props}
                                    autoComplete='off'
                                    fullWidth
                                    variant='outlined'
                                    name="businessPhone"
                                    {...getFieldProps("businessPhone")}
                                 />}
                              />
                              {errors.businessPhone && touched.businessPhone && <FormHelperText error>{errors.businessPhone}</FormHelperText>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <FormControl fullWidth className="mb-3">
                              <InputLabel id="demo-simple-select-label">Role</InputLabel>
                              <Select
                                 labelId="demo-simple-select-label"
                                 id="vendor_role_id"
                                 label="Role"
                                 value={vendorRoleId}
                                 name="vendor_role_id"
                                 {...getFieldProps('vendor_role_id')}

                                 onChange={(e) => {
                                    handleRoleOnChange(e);
                                    setFieldTouched("vendor_role_id", true)
                                    setFieldValue("vendor_role_id", e.target.value)
                                 }}
                              >
                                 {
                                    roleDatas?.map((result, i) => {
                                       return (
                                          <MenuItem value={result._id} key={i} >
                                             {result.name}
                                          </MenuItem>
                                       )

                                    })
                                 }
                              </Select>
                              {errors.vendor_role_id && touched.vendor_role_id && <FormHelperText error>{errors.vendor_role_id}</FormHelperText>}
                           </FormControl>
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <ShowImage modalId={Id} profilePic={profilePic} showImage={showImage} folderName="vendor/" onRemoveFunc={() => { removeImage() }} />
                        <Button
                           className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                           variant="contained"
                           component="label"
                           style={{ "borderRadius": 5 }}
                        >
                           {Id ? 'Change image' : 'Select Image'}
                           <input
                              hidden
                              accept="image/*"
                              onChange={(event) => {
                                 const files = event.target.files[0];
                                 if (files !== undefined) {
                                    setFlag('asd')
                                    handleProfilePicOnChange(files);
                                 }
                              }}
                              type="file"
                           />
                        </Button>
                        <FormHelperText error>
                           {errors.image}
                        </FormHelperText>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <LoadingButton
                              type='submit'
                              fullWidth
                              className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                              loading={buttonLoading}
                              loadingPosition="end"
                              variant="contained"
                           >
                              submit
                           </LoadingButton>
                        </div>
                     </div>
                  </Form>
               </FormikProvider>
            </DialogContent>
         </Dialog>
      </>
   )
}

export default SubVendor